import z from "zod/v4";
import { leagueIdSchema } from "../enums/LeagueId.ts";

export const liveBasketballTeamStatsSchema = z.object({
  stat_type: z.literal("LiveBasketballTeamStats"),
  efg: z.number().nullish(),
  to: z.number(),
  ftPct: z.number().nullish(),
  fta: z.number(),
  ptsPerPos: z.number().nullish(),
  ast: z.number(),
  threePtPct: z.number().nullish(),
  threePtAtt: z.number(),
  ptsInPaint: z.number(),
  reb: z.number(),
  oReb: z.number(),
});
export type LiveBasketballTeamStats = z.infer<
  typeof liveBasketballTeamStatsSchema
>;

export const liveBasketballGameControlTeamStatsSchema = z.object({
  stat_type: z.literal("LiveBasketballGameControlTeamStats"),
  largestLead: z.number().nullish(),
  fivePtRuns: z.number(),
  tenPtRuns: z.number(),
  mostUnansweredPts: z.number().nullish(),
  timeLeadingSecs: z.number(),
  possLeading: z.number(),
  twoMinDroughts: z.number(),
  biggestComeback: z.number().nullish(),
});
export type LiveBasketballGameControlTeamStats = z.infer<
  typeof liveBasketballGameControlTeamStatsSchema
>;

export const liveBasketballGameTeamStatsTeamSchema = z.object({
  teamId: z.string(),
  stats: z.union([
    liveBasketballTeamStatsSchema,
    liveBasketballGameControlTeamStatsSchema,
  ]),
});
export type LiveBasketballGameTeamStatsTeam = z.infer<
  typeof liveBasketballGameTeamStatsTeamSchema
>;

export const liveBasketballGameTeamStatsSchema = z.object({
  leagueId: leagueIdSchema,
  eventId: z.string(),
  home: liveBasketballGameTeamStatsTeamSchema,
  away: liveBasketballGameTeamStatsTeamSchema,
});
export type LiveBasketballGameTeamStats = z.infer<
  typeof liveBasketballGameTeamStatsSchema
>;

export const anyLiveGameTeamStatsSchema = z.union([
  liveBasketballGameTeamStatsSchema,
]);
export type AnyLiveGameTeamStats = z.infer<typeof anyLiveGameTeamStatsSchema>;
